import { Form } from "react-bootstrap";

export default function LearningOutcomeLabel(props) {
    return (
        <Form.Label>
            {props.mapping.text}
        </Form.Label>
    )
}